// extracted by mini-css-extract-plugin
export var orderSummary = "_i0-0";
export var showMoreLessButton = "_i0-1";